import { render, staticRenderFns } from "./ManageModal.vue?vue&type=template&id=1270aecc&scoped=true"
import script from "./ManageModal.vue?vue&type=script&lang=js"
export * from "./ManageModal.vue?vue&type=script&lang=js"
import style0 from "./ManageModal.vue?vue&type=style&index=0&id=1270aecc&prod&lang=scss&scoped=true"
import style1 from "./ManageModal.vue?vue&type=style&index=1&id=1270aecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270aecc",
  null
  
)

export default component.exports